<template>
  <div class="wt-agent-dropdown">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
        <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled">
          <option :value="null" v-show="currentValueDefined">Please Select</option>
          <option :value="undefined" v-show="!currentValueDefined">Please Select</option>
          <option v-for="val in values" :value="val.id" :key="val.id">{{val.name}}</option>
        </select>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import fetchPortalJson from '@/js/PortalFetchJson'
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'

export default {
  name: 'WarmTransferAgentDropDown',
  props: ['campaignId'],
  mixins: [PropsMixin, ComputedMixin],
  data () {
    return {
      wtAgents: []
    }
  },
  methods: {
    async getAgents () {
      this.wtAgents = (await fetchPortalJson(`warm_transfer_agents?campaign_id=${this.campaignId}${this.currentCampus ? '&campus_id=' + this.currentCampus : ''}${this.currentProgram ? '&program_id=' + this.currentProgram : ''}`)).warm_transfer_agents
    }
  },
  computed: {
    values () {
      return this.wtAgents
    }
  },
  mounted () {
    if (this.wtAgents.length < 1) {
      this.getAgents()
    }
  },
  watch: {
  }
}
</script>
